export const LIST_EBOOKS = `homepage/list-ebook`;
